import { render } from "./MoveNodeModal.vue?vue&type=template&id=165e234f"
import script from "./MoveNodeModal.vue?vue&type=script&lang=js"
export * from "./MoveNodeModal.vue?vue&type=script&lang=js"
script.render = render

export default script